export const loadTinyMCEDependencies = () =>
  Promise.all([
    import('tinymce/tinymce'),
    import('tinymce/models/dom/model'),
    import('tinymce/themes/silver'),
    import('tinymce/icons/default'),
    import('tinymce/skins/ui/oxide/skin'),
    import('tinymce/plugins/code'),
    import('tinymce/plugins/link'),
    import('tinymce/plugins/table'),
    import('tinymce/plugins/lists'),
    import('tinymce/plugins/preview'),
    import('tinymce/plugins/advlist'),
    import('tinymce/plugins/autolink'),
    import('tinymce/plugins/autoresize'),
    import('tinymce/plugins/charmap'),
    import('tinymce/plugins/code'),
    import('tinymce/plugins/codesample'),
    import('tinymce/plugins/directionality'),
    import('tinymce/plugins/autosave'),
    import('tinymce/plugins/fullscreen'),
    import('tinymce/plugins/anchor'),
    import('tinymce/plugins/help/js/i18n/keynav/en'),
    import('tinymce/plugins/help'),
    import('tinymce/plugins/searchreplace'),
    import('tinymce/plugins/image'),
    import('tinymce/plugins/importcss'),
    import('tinymce/plugins/insertdatetime'),
    import('tinymce/plugins/nonbreaking'),
    import('tinymce/plugins/pagebreak'),
    import('tinymce/plugins/quickbars'),
    import('tinymce/plugins/save'),
    import('tinymce/plugins/media'),
    import('tinymce/plugins/visualblocks'),
    import('tinymce/plugins/visualchars'),
    import('tinymce/plugins/emoticons'),
    import('tinymce/plugins/wordcount'),
    import('tinymce/plugins/emoticons/js/emojis'),
  ])
